export default "__VITE_ASSET__DxS46ZOE__"